export default __webpack_public_path__ + "static/media/ThinkTicket.7b0734331569058690bae31abe48a234.webp";